import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatTableModule} from "@angular/material/table";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {FeatherIconsComponent} from "@shared/components/feather-icons/feather-icons.component";
import {MatRippleModule} from "@angular/material/core";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatPaginator, MatPaginatorModule} from "@angular/material/paginator";
import {NgOptimizedImage} from "@angular/common";
import {TableElement, TableExportUtil, UnsubscribeOnDestroyAdapter} from "@shared";
import {HttpClient} from "@angular/common/http";
import {MatDialog} from "@angular/material/dialog";
import {fromEvent} from "rxjs";
import {HealthEventService} from "@core/http/table-data-services/healthEvent.service";
import {HealthEventDataSource} from "@core/data-source/HealthEventDataSource";
import {HealthEvent} from "@core/models/HealthEvent";
import {HealthEventCreateEditComponent} from "./health-event-create-edit/health-event-create-edit.component";
import {DoDeleteComponent} from "@shared/components/do-delete/do-delete.component";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";

@Component({
  selector: 'app-health-events',
  standalone: true,
  imports: [
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    FeatherIconsComponent,
    MatRippleModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    NgOptimizedImage,
  ],
  templateUrl: './health-events.component.html',
  styleUrl: './health-events.component.scss'
})
export class HealthEventsComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit {

  displayedColumns = [
    'nombre',
    'acciones'
  ];

  data?: HealthEventService;
  dataSource!: HealthEventDataSource;
  index?: number;
  idEvento?: number;
  healthEvent?: HealthEvent;
  @ViewChild(MatPaginator, {static: true})
  paginator!: MatPaginator;
  @ViewChild(MatSort, {static: true})
  sort!: MatSort;
  @ViewChild('filter', {static: true}) filter?: ElementRef;

  constructor(
    public httpClient: HttpClient,
    public dialog: MatDialog,
    public healthEventService: HealthEventService,
    private cd: ChangeDetectorRef,
    private httpMsgHandler: HttpMesageHandlerService
  ) {
    super();
  }

  ngOnInit() {
    this.loadData();
    this.cd.detectChanges();

  }

  refresh() {
    this.ngOnInit();
  }

  addNew() {
    this.healthEvent = new HealthEvent({
      idEvento: this.data!.data.length + 1,
      nombreEvento: ''
    })
    const dialogRef = this.dialog.open(HealthEventCreateEditComponent, {
      data: {
        entity: this.healthEvent,
        action: 'add',
      }
    });

    // noinspection DuplicatedCode
    this.subs.sink = dialogRef.afterClosed().subscribe((result) => {
      if (result === 1) {
        this.data?.dataChange.value.unshift(
          this.healthEventService.getDialogData()
        );
        this.refresh();
        this.refreshTable();
      }
    });
  }

  editCall(row: HealthEvent) {
    this.idEvento = row.idEvento;

    const dialogRef = this.dialog.open(HealthEventCreateEditComponent, {
      data: {
        entity: row,
        action: 'edit',
      },
    });
    this.subs.sink = dialogRef.afterClosed().subscribe((result) => {
      if (result === 1) {
        const foundIndex = this.data?.dataChange.value.findIndex(
          (x) => x.idEvento === this.idEvento
        );
        if (foundIndex != null && this.data) {
          this.data.dataChange.value[foundIndex] =
            this.healthEventService.getDialogData();
          this.refresh();
          this.refreshTable();
        }
      }
    });
  }

  deleteItem(row: HealthEvent) {
    this.idEvento = row.idEvento;

    const dialogRef = this.dialog.open(DoDeleteComponent, {
      data: {
        toDelete: 'EVENTO DE SALUD',
        id: this.idEvento,
        name: row.nombreEvento,
        actionService: (id: string) => this.healthEventService.deleteHealthEvent(id),
      }
    });
    this.subs.sink = dialogRef.afterClosed().subscribe((result) => {
      if (result === 1) {
        const foundIndex = this.data?.dataChange.value.findIndex(
          (x): boolean => x.idEvento === this.idEvento
        );
        if (foundIndex != null && this.data) {
          this.data.dataChange.value.splice(foundIndex, 1);

          this.refreshTable();
        }
      }
    });
  }

  public loadData() {
    this.data = new HealthEventService(this.httpClient, this.httpMsgHandler);
    this.dataSource = new HealthEventDataSource(
      this.data,
      this.paginator,
      this.sort
    );
    this.subs.sink = fromEvent(this.filter?.nativeElement, 'keyup').subscribe(
      () => {
        if (!this.dataSource) {
          return;
        }
        this.dataSource.filter = this.filter?.nativeElement.value;
      }
    );
  }

  exportExcel() {
    const exportData: Partial<TableElement>[] =
      this.dataSource.filteredData.map((x) => ({
        idEvento: x.idEvento,
        Nombre: x.nombreEvento,
      }));
    TableExportUtil.exportToExcel(exportData, 'excel');
  }

  private refreshTable() {
    this.paginator._changePageSize(this.paginator.pageSize);
    this.cd.detectChanges();
  }
}
